import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Container, Row, Col } from "react-bootstrap";

const AnimalSafariSkeleton = () => {
  return (
    <div className="animal-safari mb-4">
      <div className="inner_animals position-relative">
        <Skeleton height={240} className="w-100" />

        <div className="safariBox">
          <Container>
            <Row className="align-items-center">
              <Col lg={6} md={5} xs={4} className="text-center pt-5">
                <Skeleton  height={180} width={150} />
              </Col>
              <Col lg={6} md={7} xs={8}>
                <div className="safari_content">
                  <h3>
                    <Skeleton width={`60%`} />
                  </h3>
                  <p className="two-line-text">
                    <Skeleton count={2} />
                  </p>
                  <div className="knowmore mt-2">
                    <Skeleton height={36} width={120} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default AnimalSafariSkeleton;
